
<div class="modal-dialog" style="max-width: 800px;">
  <div class="modal-content">
    <div class="modal-body">
      <p><b>Warning:</b> You have unsaved changes!</p>
    </div>
    <div class="modal-footer">
      <button class="btn btn-outline-primary" type="button" (click)="closeDialog(&quot;cancel&quot;)">Cancel</button>
      <button class="btn btn-outline-danger" type="button" (click)="closeDialog(&quot;continue&quot;)">Discard Changes</button>
      <button class="btn btn-primary" type="button" (click)="closeDialog(&quot;save&quot;)">Save And Continue</button>
    </div>
  </div>
</div>